<template>
  <div>
    <span style="margin-left: 5px">{{
      params.Title ? params.Title[language] : null
    }}</span>
    <span v-if="params.Required && !params.Label" style="color: red">*</span>
    <fp-input
      :placeholder="params.PlaceHolder ? params.PlaceHolder[language] : null"
      :description="params.Description ? params.Description[language] : null"
      :required="params.Required"
      :disabled="!params.Enabled != false || disabled"
      :state="checkValidInput"
      :error="
        $t('validate.numberMinMax', {
          min: params.Minimum,
          max: params.Maximum,
        })
      "
      textStyle="dark"
      type="number"
      v-model="inputValue"
    />
  </div>
</template>
<script>
export default {
  name: "Float",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    params: Object,
    value: [Number, String],
    disabled: Boolean,
    language: String,
  },
  computed: {
    checkValidInput() {
      if (
        this.inputValue > this.params.Maximum ||
        this.inputValue < this.params.Minimum
      ) {
        return false;
      }
      return true;
    },
    inputValue: {
      get() {
        return this.value ? this.value : this.params.DefaultValue;
      },
      set(value) {
        this.$emit("change", value);
      },
    },
  },
};
</script>